import React from 'react';

import { IonIcon } from '@ionic/react';
import { alertCircle } from 'ionicons/icons';

import clsx from 'clsx';

import ProgressBar from 'components/ProgressBar';
import Typography from 'components/Typography';

import './index.css';

interface IErrorContent {
  icon?: string;
  text?: string;
  error?: string;
  withBorder?: boolean;
  withRadius?: boolean;
  isRefetching?: boolean;
  children?: React.ReactNode;
}

const ErrorContent = ({
  icon = alertCircle,
  text = 'Something went wrong.',
  error = 'Please try again later.',
  isRefetching = false,
  withBorder = false,
  withRadius = withBorder,
  children = null,
}: IErrorContent) => {
  return (
    <div
      className={clsx('error-content', {
        border: withBorder,
        radius: withRadius,
      })}
    >
      {Boolean(icon) && (
        <IonIcon
          icon={icon}
          size={'large'}
          color={'danger'}
          className={'ion-padding'}
        />
      )}
      {Boolean(text) && <Typography color={'danger'}>{text}</Typography>}
      {Boolean(error) && <Typography color={'danger'}>{error}</Typography>}
      {children}
      {isRefetching && <ProgressBar type={'indeterminate'} />}
    </div>
  );
};
export default ErrorContent;
